import { render } from "./SearchAndCreateBox.vue?vue&type=template&id=c23a7eac&scoped=true&lang=pug"
import script from "./SearchAndCreateBox.vue?vue&type=script&lang=js"
export * from "./SearchAndCreateBox.vue?vue&type=script&lang=js"

import "./SearchAndCreateBox.vue?vue&type=style&index=0&id=c23a7eac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23a7eac"]])

export default __exports__